import { ApiService } from "../../../config/apiServices";
import {
  GET_USP_MENU_LIST,
  GET_USP_MENU_ADMIN_LIST,
  GET_USP_MENU_BY_ID,
  CREATE_USP_MENU,
  UPDATE_USP_MENU,
  DELETE_USP_MENU,
} from "../../../config/adminUrlConfig";

export const getMenuList = () => {
  try {
    return ApiService.get(GET_USP_MENU_LIST);
  } catch (error) {
    return error.message;
  }
};

export const getMenuAdminList = (perPage,currentPage) => {
  try {
    return ApiService.get(
      `${GET_USP_MENU_ADMIN_LIST}?number=${perPage}&page=${currentPage}`
    );
  } catch (error) {
    return error.message;
  }
};

export const getMenuItemById = (id) => {
  try {
    return ApiService.get(`${GET_USP_MENU_BY_ID}/${id}`);
  } catch (error) {
    return error.message;
  }
};

export const createMenuItem = (payload) => {
  try {
    return ApiService.post(CREATE_USP_MENU, payload);
  } catch (error) {
    return error.message;
  }
};

export const updateMenuItem = (id, payload) => {
  try {
    return ApiService.post(`${UPDATE_USP_MENU}/${id}`, payload);
  } catch (error) {
    return error.message;
  }
};

export const deleteMenuItem = (id) => {
  try {
    return ApiService.delete(`${DELETE_USP_MENU}/${id}`);
  } catch (error) {
    return error.message;
  }
};

